import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store/index';
Vue.use(VueRouter);

const rejectAuthLoginUser = (to, from, next) => {
  if (store.state.authStore.isLoginSuccess == true) {
    next('/dashboard');
    return;
  }
  next();
};

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'main',
      redirect: '/dashboard',
      meta: { auth: true },
    },
    {
      path: '/',
      component: () => import('@/views/layout/Index.vue'),
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('@/views/page/Dashboard.vue'),
        },
        {
          path: '/analyze/ips',
          name: 'ips-analyze',
          component: () => import('@/views/page/analyze/ips-analyze.vue'),
        },
        {
          path: '/analyze/l7',
          name: 'l7-analyze',
          component: () => import('@/views/page/analyze/l7-analyze.vue'),
        },
        {
          path: '/analyze/http',
          name: 'http-analyze',
          component: () => import('@/views/page/analyze/http-analyze.vue'),
        },
        {
          path: '/analyze/firewall',
          name: 'firewall-analyze',
          component: () => import('@/views/page/analyze/firewall-analyze.vue'),
        },
        {
          path: '/analyze/traffic',
          name: 'traffic-analyze',
          component: () => import('@/views/page/analyze/traffic-analyze.vue'),
        },
        {
          path: '/report',
          name: 'report',
          component: () => import('@/views/page/report/Report.vue'),
        },
        {
          path: '/setting/userinfo',
          name: 'setting-userinfo',
          component: () => import('@/views/page/setting/ChangeUserInfo.vue'),
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      beforeEnter: rejectAuthLoginUser,
      component: () => import('@/views/auth/Login.vue'),
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const userData = {
    user_login: store.state.authStore.selectUser,
    user_token: store.state.authStore.token,
  };

  const data = await store.dispatch('authStore/NssSessionCheck', userData);

  if (to.path !== '/login') {
    if (data.success === 'false') {
      await store.dispatch('authStore/LOGOUT');
      if (store.state.authStore.isLoginSuccess == false) {
        next('/login');
      }
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
